export default __webpack_public_path__ + "a9a64edbd49978756b41735c725870ec.ogg";